//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    blockName: { type: String, default: '' },
    products: { type: Object, required: true },
    isLE: { type: Boolean, default: false },
    skuField: { type: String, default: 'sku' }
  },
  computed: {
    prices () {
      return Object.keys(this.products).map((product) => {
        const bestsellers = this.$store.getters['product/bestsellers'](product.split('-')[0])
        return this.$store.getters['product/priceFromSku']((bestsellers[0] || {})[this.skuField])
      })
    },
    minPrice () {
      return Math.min(...this.prices)
    },
    titleWithPrice () {
      return this.$tr(this.title.replace('%MINPRICE%', '{minProductPrice}'), { minProductPrice: this.$tcl(this.minPrice, true) })
    }
  }
}
